// @flow
import React, { useContext } from 'react';

import { mapCategories } from 'Client/cms/toolkit/product-utils/productFeatures.utils';
import { productChildcareDetailQuery } from 'Client/cms/toolkit/product-utils/productFeatures.queries';
import { useRouter } from 'Client/router/useRouter';
import { ProductFeatureDetail } from 'Components/widgets/product-feature-detail/ProductFeatureDetail.jsx';
import { ProductFeatures } from 'Components/widgets//product-features/ProductFeatures.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import ReactAppContext from 'Context/ReactAppContext';
import { addTranslationKeys } from 'Src/i18n';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES } from 'Utils/request/requestDictionary';
import { TRACKING_PREFIX_MAPPING } from 'Utils/tracking/resort';

export const ProductChildcaresLine = (props: ProductChildcaresLineProps) => {
  const {
    config: {
      common: { childcarealacarte, loadLess, scrollBackward, scrollForward, viewMore },
    },
    id,
    resort,
  } = props;
  const { location } = useRouter<UrlParams, QueryParams>();
  const appContext = useContext(ReactAppContext);

  if (!resort) {
    return null;
  }

  const fetchActivityServices = ({ productId, activityId }) => {
    const query = productChildcareDetailQuery(productId, activityId, {
      lineProps: props,
      urlParams: location.urlParams,
    });
    return graphQLClient
      .runQuery(query, appContext, {
        requestName: WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES,
      })
      .then(data => {
        addTranslationKeys(data.config);
        return {
          productActivities: {
            ...data.productActivities,
            resort: data.resort,
            includedServices: data.includedServices,
            onDemandServices: data.onDemandServices,
          },
        };
      });
  };

  const introduction = {
    seeLessLabel: loadLess,
    seeMoreLabel: viewMore,
    text:
      (resort.kidsActivitiesIntroduction && resort.kidsActivitiesIntroduction.description) || '',
    title:
      (resort.kidsActivitiesIntroduction && resort.kidsActivitiesIntroduction.shortDescription) ||
      '',
  };

  const productActivitiesCategories =
    resort.categories && resort.categories.children
      ? resort.categories.children.filter(({ activities }) => activities && activities.length !== 0)
      : [];

  const productCategories = mapCategories({
    fetchActivityServices,
    hasBanner: true,
    labelGAPrefix: TRACKING_PREFIX_MAPPING.CHILDCARE,
    notIncludedMessage: childcarealacarte,
    productActivitiesCategories,
    productFeaturesLineData: props,
  });

  return (
    <SiteContainer className="Line" id={id}>
      <ProductFeatures
        categories={productCategories}
        introduction={introduction}
        labelGAPrefix={TRACKING_PREFIX_MAPPING.CHILDCARE}
        queryLayer="productChildcaresLayer"
        renderDetail={data => <ProductFeatureDetail {...data} />}
        scrollBackwardLabel={scrollBackward}
        scrollForwardLabel={scrollForward}
      />
    </SiteContainer>
  );
};
